var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-about"},[_c('div',{staticClass:"section-title"},[_vm._v("关于我们")]),_c('div',{staticClass:"about-content",domProps:{"innerHTML":_vm._s(_vm.aboutContent.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }